<template>
  <div class="home">
    <!-- 顶部介绍 -->
    <section class="hero">
      <h1 class="main-title">AI助力大学生简历优化，让简历更专业，求职管理更高效</h1>
      <p class="sub-title">专为大学生打造的助手，提供简历优化和资源管理工具</p>
    </section>

    <!-- 功能卡片区域 -->
    <section class="feature-cards">
      <el-row :gutter="30">
        <!-- 简历优化卡片 -->
        <el-col :xs="24" :sm="12">
          <el-card class="feature-card" shadow="hover" @click="goToResume">
            <div class="card-content">
              <el-icon class="card-icon"><Document /></el-icon>
              <h2 class="card-title">简历优化</h2>
              <p class="card-desc">
                使用STAR法则-情境、任务、行动、结果-优化项目经历描述，让简历更具说服力
              </p>
              <el-button type="primary" class="card-btn">开始优化</el-button>
            </div>
          </el-card>
        </el-col>
        
        <!-- 资源管理卡片 -->
        <el-col :xs="24" :sm="12">
          <el-card class="feature-card" shadow="hover" @click="goToResources">
            <div class="card-content">
              <el-icon class="card-icon"><Management /></el-icon>
              <h2 class="card-title">资源管理</h2>
              <p class="card-desc">
                自主整理资源-公司、职位、投递进度、经验贴-通过仪表盘让求职过程井然有序
              </p>
              <el-button type="primary" class="card-btn">开始管理</el-button>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </section>

    <!-- 关于 -->
    <section class="contact-section">
      <h2 class="section-title">关于</h2>
      <div class="contact-desc">
        <p class="desc-paragraph">
          本网站由个人开发，秉持免费无广告的理念，致力于提升大学生求职体验。
        </p>
        <p class="desc-paragraph">
          本网站专注于简历优化和求职资源管理两大核心功能。在资源管理方面，仅作为个人自我资源的整理工具，供用户管理自主收集的资源，网站不提供任何资源内容。对于用户自行收集整理的内容，本网站不承担相关责任。
        </p>
        <p class="desc-paragraph highlight">
          希望各位都能在人生的岔路口找到东南西北~
        </p>
      </div>
      <el-button type="primary" plain @click="goToAbout">了解更多</el-button>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { Document, Management } from '@element-plus/icons-vue';

export default defineComponent({
  name: 'HomeView',
  components: {
    Document,
    Management
  },
  setup() {
    const router = useRouter();

    // 导航方法
    const goToResume = () => {
      router.push('/resume');
    };

    const goToResources = () => {
      router.push('/resources');
    };

    const goToAbout = () => {
      router.push('/about');
    };

    return {
      goToResume,
      goToResources,
      goToAbout
    };
  }
});
</script>

<style lang="scss" scoped>
.home {
  width: 85%;
  margin: 0 auto;
  padding: 0;
}

.hero {
  text-align: center;
  padding: 60px 0 70px;
  
  .main-title {
    font-size: 2.4rem;
    font-weight: 700;
    margin-bottom: 20px;
    background: linear-gradient(45deg, #222, #555);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    line-height: 1.2;
  }
  
  .sub-title {
    font-size: 1.15rem;
    color: #555;
    max-width: 800px;
    margin: 0 auto;
    line-height: 1.6;
  }
}

.feature-cards {
  margin-bottom: 70px;
  
  .feature-card {
    height: 100%;
    transition: transform 0.3s, box-shadow 0.3s;
    border-radius: 16px !important;
    overflow: hidden;
    cursor: pointer;
    background-color: #fff;
    
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08) !important;
    }
    
    .card-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding: 40px 24px;
    }
    
    .card-icon {
      font-size: 3rem;
      margin-bottom: 24px;
      color: #333;
    }
    
    .card-title {
      font-size: 1.5rem;
      margin-bottom: 16px;
      font-weight: 600;
      color: #222;
    }
    
    .card-desc {
      color: #555;
      margin-bottom: 24px;
      line-height: 1.6;
    }
    
    .card-btn {
      margin-top: auto;
      border-radius: 10px !important;
      padding: 10px 24px;
      font-weight: 500;
    }
  }
}

.contact-section {
  margin-bottom: 70px;
  text-align: center;
  
  .section-title {
    text-align: center;
    font-size: 1.9rem;
    margin-bottom: 40px;
    position: relative;
    color: #222;
    
    &:after {
      content: '';
      position: absolute;
      bottom: -12px;
      left: 50%;
      transform: translateX(-50%);
      width: 50px;
      height: 3px;
      background: #333;
      border-radius: 3px;
    }
  }

  .contact-desc {
    max-width: 800px;
    margin: 0 auto 30px;
    color: #555;
    line-height: 1.6;
    font-size: 1.05rem;
    text-align: center;
    padding: 0 20px;
    
    .desc-paragraph {
      margin-bottom: 20px;
      max-width: 720px;
      margin-left: auto;
      margin-right: auto;
      
      &:last-child {
        margin-bottom: 32px;
      }
      
      &.highlight {
        color: #333;
        font-weight: 500;
        font-size: 1.15rem;
        margin-top: 32px;
        font-style: italic;
      }
    }
  }
}

// 响应式调整
@media (max-width: 768px) {
  .hero {
    padding: 40px 0 50px;
    
    .main-title {
      font-size: 2rem;
    }
    
    .sub-title {
      font-size: 1.05rem;
    }
  }
  
  .feature-cards {
    .el-col {
      margin-bottom: 20px;
    }
    
    .feature-card {
      .card-content {
        padding: 30px 20px;
      }
      
      .card-icon {
        font-size: 2.6rem;
      }
      
      .card-title {
        font-size: 1.4rem;
      }
    }
  }
  
  .contact-section {
    .section-title {
      font-size: 1.7rem;
    }
  }
}
</style>
